import { render, staticRenderFns } from "./baobiaostu.vue?vue&type=template&id=0dc1d194&scoped=true"
import script from "./baobiaostu.vue?vue&type=script&lang=js"
export * from "./baobiaostu.vue?vue&type=script&lang=js"
import style0 from "./baobiaostu.vue?vue&type=style&index=0&id=0dc1d194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc1d194",
  null
  
)

export default component.exports